import { render, staticRenderFns } from "./CreditResults.vue?vue&type=template&id=087cbfd0"
import script from "./CreditResults.ts?vue&type=script&lang=ts&external"
export * from "./CreditResults.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports